export * from './web-frame.component';
